import { OPEN_SLIDER, TOGGLE_SLIDER } from '../actionTypes/SliderActionTypes';

export const showSlider = () => ({
    type: OPEN_SLIDER,
});

export const toggleSlider = () => ({
    type: TOGGLE_SLIDER,
});
